import { render, staticRenderFns } from "./etapa_8.vue?vue&type=template&id=f447a1c6&scoped=true&"
import script from "./etapa_8.vue?vue&type=script&lang=js&"
export * from "./etapa_8.vue?vue&type=script&lang=js&"
import style0 from "./etapa_8.vue?vue&type=style&index=0&id=f447a1c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f447a1c6",
  null
  
)

export default component.exports